"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
var _merchantElectricity = require("@/api/merchantElectricity");
var _utils = require("./utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MerchantElectricityDailyUsage',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  data: function data() {
    return {
      listLoading: false,
      exportLoading: false,
      list: [],
      tableMaxH: 400,
      listQuery: {
        start: 1,
        limit: 20,
        page_num: 0,
        total: 0
      },
      filter: {
        merchant_aid: '',
        store_id: '',
        dateRange: null
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    formatKwh: _utils.formatKwh,
    toQuery: function toQuery() {
      this.$refs.filterDrawer && this.$refs.filterDrawer.hide();
      this.listQuery.start = 1;
      this.getList();
    },
    resetQuery: function resetQuery() {
      this.filter = {
        merchant_aid: '',
        store_id: '',
        dateRange: null
      };
      this.listQuery.start = 1;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = {
        start: this.listQuery.start - 1,
        limit: this.listQuery.limit
      };
      if (this.filter.merchant_aid) params.merchant_aid = this.filter.merchant_aid;
      if (this.filter.store_id) params.store_id = this.filter.store_id;
      if (this.filter.dateRange && this.filter.dateRange.length === 2) {
        params.date_start = this.filter.dateRange[0];
        params.date_end = this.filter.dateRange[1];
      }
      (0, _merchantElectricity.getDailyUsageList)(params).then(function (res) {
        _this.list = res && res.list || [];
        var total = res && res.total != null ? res.total : 0;
        _this.listQuery.total = total;
        _this.listQuery.page_num = Math.ceil(total / _this.listQuery.limit) || 0;
        if (params.start === 0 && _this.$refs.list_table) {
          _this.$nextTick(function () {
            _this.tableMaxH = window.innerHeight - _this.$refs.list_table.$el.offsetTop - 80;
          });
        }
      }).catch(function (err) {
        _this.$message.error(err && err.msg || '加载失败');
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    buildUsageExportParams: function buildUsageExportParams() {
      var params = {};
      if (this.filter.merchant_aid) params.merchant_aid = this.filter.merchant_aid;
      if (this.filter.store_id) params.store_id = this.filter.store_id;
      if (this.filter.dateRange && this.filter.dateRange.length === 2) {
        params.date_start = this.filter.dateRange[0];
        params.date_end = this.filter.dateRange[1];
      }
      return params;
    },
    handleExportUsage: function handleExportUsage() {
      var _this2 = this;
      var params = this.buildUsageExportParams();
      if (!params.date_start || !params.date_end) {
        this.$message.warning('请选择日期范围后再导出');
        return;
      }
      this.exportLoading = true;
      (0, _merchantElectricity.exportDailyUsage)(params).catch(function () {}).finally(function () {
        _this2.exportLoading = false;
      });
    }
  }
};